import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { toast } from '@/components/Toast';
import { tokenParamFromSdk } from '@/utils';
import { LoginTokenDto } from '@/services/login/token';

let tokenRefreshPromise: Promise<LoginTokenDto> | null;

export function createAxios(config?: AxiosRequestConfig) {
  const instance = Axios.create({
    ...config,
    headers: {
      ...(config ? config.headers : {}),
    },
  });

  instance.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${token.value()}`;
    return config;
  });

  instance.interceptors.response.use(
    async function (response) {
      const code = response.data.code as number;
      if (code === 6002) {
        tokenRefreshPromise =
          tokenRefreshPromise ||
          instance.post<LoginTokenDto>('/ico/login/token', {
            ...tokenParamFromSdk(),
            loginSource: 'miniApp',
          });

        await tokenRefreshPromise.then((data) => {
          tokenRefreshPromise && token.set(data);
          tokenRefreshPromise = null;
        });

        return instance(response.config);
      } else if (code !== 0) {
        toast.error(response.data.msg);
        return Promise.reject(response.data);
      }

      if (response.config.url?.startsWith('/ico/login/token')) {
        token.set(response.data.data as LoginTokenDto);
      }
      return response.data.data;
    },
    function ({
      message,
      response,
    }: {
      message: string;
      response?: AxiosResponse<{ message: string }, AxiosRequestConfig>;
      config: AxiosRequestConfig;
    }) {
      toast.error(message || response?.message || 'Network error');
      return Promise.reject('Network error');
    }
  );

  return instance;
}

export default createAxios({ baseURL: import.meta.env.VITE_API_HOST });

let locale: LoginTokenDto;
export const token = {
  get(): LoginTokenDto | null {
    try {
      locale = locale || JSON.parse(localStorage.getItem('__token') || '{}');
      return locale;
    } catch {
      return null;
    }
  },
  set(value: LoginTokenDto) {
    locale = value;
    localStorage.setItem('__token', JSON.stringify(value));
  },
  value() {
    return this.get()?.token;
  },
  validate() {
    if (locale && locale.expired > Date.now()) {
      return true;
    } else {
      return false;
    }
  },
};
